export const APPLICATION_LOADING = 'APPLICATION_LOADING'
export const SET_PROPERTY = 'SET_PROPERTY'
export const SET_META = 'SET_META'
export const SET_ITEMS = 'SET_ITEMS'
export const ADD_ITEMS = 'ADD_ITEMS'
export const REMOVE_ITEM = 'REMOVE_ITEM'

export const SET_USER = 'SET_USER'
export const SET_USERS = 'SET_USERS'

export const UPDATE_SIZE = 'UPDATE_SIZE'
export const UPDATE_PRODUCT = 'UPDATE_PRODUCT'
export const UPDATE_STATION = 'UPDATE_STATION'
export const UPDATE_FIREFIGHTER = 'UPDATE_FIREFIGHTER'
export const UPDATE_REQUEST = 'UPDATE_REQUEST'
export const UPDATE_REQUESTS = 'UPDATE_REQUESTS'

export const SET_SELECTED = 'SET_SELECTED'

export const SET_INVOICE_RUNS = 'SET_INVOICE_RUNS'
export const RESET_INVOICE_RUNS = 'RESET_INVOICE_RUNS'
export const ADD_INVOICE_RUN = 'ADD_INVOICE_RUN'
export const ADD_INVOICE_RUNS = 'ADD_INVOICE_RUNS'
export const REMOVE_INVOICE_RUN = 'REMOVE_INVOICE_RUN'
export const SET_INVOICE_RUN = 'SET_INVOICE_RUN'
export const RESET_INVOICE_RUN = 'RESET_INVOICE_RUN'

export const ADD_INVOICE = 'ADD_INVOICE'
export const REMOVE_INVOICE = 'REMOVE_INVOICE'
export const UPDATE_INVOICE = 'UPDATE_INVOICE'
export const RESET_INVOICE = 'RESET_INVOICE'

export const SET_XERO_LINK = 'SET_XERO_LINK'
export const SET_XERO_DATA = 'SET_XERO_DATA'

export const SET_INVENTORIES = 'SET_INVENTORIES'
export const RESET_INVENTORIES = 'RESET_INVENTORIES'
export const ADD_INVENTORY = 'ADD_INVENTORY'
export const ADD_INVENTORIES = 'ADD_INVENTORIES'
export const REMOVE_INVENTORY = 'REMOVE_INVENTORY'
export const SET_INVENTORY = 'SET_INVENTORY'
export const RESET_INVENTORY = 'RESET_INVENTORY'
